import { Component, OnInit, Input, ElementRef } from '@angular/core';
import { Subject } from 'rxjs';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Region } from 'src/app/models/region';
import { ToastService } from 'src/app/services/toast.service';
import { GeoService } from 'src/app/services/geo.service';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { BsLocaleService } from 'ngx-bootstrap/datepicker';
import * as moment from "moment";
import { KeyValue } from 'src/app/models/keyValue';

@Component({
  selector: 'app-edit-region-modal',
  templateUrl: './edit-region-modal.component.html',
  styleUrls: ['./edit-region-modal.component.css']
})
export class EditRegionModalComponent implements OnInit {
  @Input() currentRegion: Region;
  public onClose: Subject<boolean>;
  submitted: boolean = false;
  editForm: FormGroup;
  nations: KeyValue[];  
  constructor(
    private geoService: GeoService,
    private formBuilder: FormBuilder,
    public bsModalRef: BsModalRef,
    private el: ElementRef,
    private localeService: BsLocaleService,
    private toastr: ToastService
  ) {
    this.localeService.use("it");    
  }

  ngOnInit() {
    this.geoService.getNations().subscribe(res => {
      this.nations = res;
    });
    this.editForm = this.initializeFormGroup();
    this.onClose = new Subject();
  }

  initializeFormGroup() {
    return this.formBuilder.group({
      id: [this.currentRegion.id],
      name: [this.currentRegion.name, [Validators.required, Validators.maxLength(255)]],
      code: [
        this.currentRegion.code,
        [Validators.required, Validators.minLength(2), Validators.maxLength(2)]
      ],
      nation: [this.currentRegion.idNation, [Validators.required]],
      fromDate: [
        this.currentRegion.fromDate ?
          moment(this.currentRegion.fromDate, "YYYY-MM-DD").format(
            "DD/MM/YYYY"
          )
        : "",
        // [Validators.required, Validators.minLength(10), Validators.maxLength(10)]
      ],
      toDate: [
        this.currentRegion.toDate ?
          moment(this.currentRegion.toDate, "YYYY-MM-DD").format(
            "DD/MM/YYYY"
          )
        : "",
        // [Validators.required, Validators.minLength(10), Validators.maxLength(10)]
      ]
    });
  }

  get f() {
    return this.editForm.controls;
  }

  onSubmit() {
    this.submitted = true;
    this.editForm.updateValueAndValidity();
    let errors = false;
    for (let c in this.f) {
      errors = errors || this.f[c].errors !== null;
      console.log(
        "this.f[" + c + "].errors:" + JSON.stringify(this.f[c].errors)
      );
    }
    if (this.editForm.invalid || errors) {
      console.log("invalid");
      let invalidElements = []; // this.el.nativeElement.querySelectorAll('.is-invalid');
      for (let el in this.editForm.controls) {
        if (this.editForm.controls[el].invalid) {
          console.log(`set focus on ${el}`);
          if (this.editForm.controls[el] instanceof FormGroup) {
            for (let el1 in this.editForm.get(el)["controls"]) {
              if (this.editForm.get(el)["controls"][el1].invalid) {
                invalidElements = this.el.nativeElement.querySelectorAll(
                  `[formcontrolname="${el1}"]`
                );
                break;
              }
            }
          } else {
            invalidElements = this.el.nativeElement.querySelectorAll(
              `[formcontrolname="${el}"]`
            );
          }
          break;
        }
      }
      if (invalidElements.length > 0) {
        invalidElements[0].focus();
      }
      return false;
    }

    const newRegion: Region = new Region();
    newRegion.id = this.f.id.value;
    newRegion.name = this.f.name.value;
    newRegion.code = this.f.code.value;
    newRegion.idNation =this.currentRegion.idNation;// this.f.nation.value;
    newRegion.fromDate = 
      this.f.fromDate.value ? moment(this.f.fromDate.value, "DD/MM/YYYY").format("YYYY-MM-DD") : null;
    newRegion.toDate = 
      this.f.toDate.value ? moment(this.f.toDate.value, "DD/MM/YYYY").format("YYYY-MM-DD") : null;

    this.geoService.createRegion(newRegion).subscribe(res => {
      this.toastr.success( "Regione aggiornata con successo!");
      this.onClose.next(true);
    }, error => {
      this.toastr.error( "Codice già presente");
    })
  }

  onChangeFromDate(value: Date) {
    value ? value.setHours(value.getHours() + 2) : null;
    this.currentRegion.fromDate = value ? moment(value).format("DD/MM/YYYY") : null;
  }

  onChangeToDate(value: Date) {
    value ? value.setHours(value.getHours() + 2) : null;
    this.currentRegion.toDate = value ? moment(value).format("DD/MM/YYYY") : null;
  }
}
